export default {
  'bindTo': 'this',
  'method': function(){
    alert('Invia Preavvisi')
  },
}
